module.exports = __webpack_public_path__ + "img/Group 3969.95eb9477.svg";